import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var classes = function classes(hidden) {
  return classNames({
    'show-hide': true,
    hidden: hidden
  });
};
var ShowHide = function ShowHide(_ref) {
  var children = _ref.children,
    hide = _ref.hide;
  return /*#__PURE__*/React.createElement("div", {
    className: classes(hide)
  }, children);
};
ShowHide.propTypes = {
  /** Set to true to hide children, defaults to false */
  hide: PropTypes.bool,
  /** Content to conditionally show or hide */
  children: PropTypes.any.isRequired
};
ShowHide.defaultProps = {
  hide: false
};
export default ShowHide;